import { ObjectType } from '../types'

export const separateFields = data => {
  const external = []
  const task = []
  const user = []

  data.forEach(item => {
    const type = item.object_type
    switch (type) {
      case ObjectType.ExternalUser:
        external.push(item)
        break
      case ObjectType.Task:
        task.push(item)
        break
      case ObjectType.User:
        user.push(item)
        break
      default:
        console.warn('Unknown object type', type)
        break
    }
  })

  return { external, task, user }
}

export const cleanList = list => {
  const cleaned = []

  list.forEach(item => {
    const {
      id,
      object_type,
      title,
      description,
      field_type,
      options,
      config,
      archived_at
    } = item

    const cleanID = item.new ? null : id
    const cleanDescription =
      (description ?? '').trim().length > 0 ? description.trim() : null
    const cleanOptions = options?.length > 0 ? options : null

    const cleanItem = {
      id: cleanID,
      object_type,
      title: title.trim(),
      description: cleanDescription,
      field_type,
      options: cleanOptions,
      config,
      archived_at
    }

    cleaned.push(cleanItem)
  })

  return cleaned
}

export const checkErrors = list => {
  for (let i = 0; i < list.length; i++) {
    const item = list[i]

    if (item.title.length === 0) {
      return 'Title must not be empty'
    }

    if (
      ['dropdown', 'multiselect'].includes(item.field_type) &&
      !item.options
    ) {
      return 'Options must not be empty'
    }
  }

  return null
}
